module.exports.URL_OBJECT = require('./config').config()